// Function to get the initial state from localStorage
const getInitialCourseState = () => {
    try {
        const storedCourseData = localStorage.getItem('course_data');
        return storedCourseData !== null ? JSON.parse(storedCourseData) : {
            course_image: '',
            course_name: '',
            course_mode: ''
        };
    } catch (error) {
        //console.error('Error reading course_data from localStorage:', error);
        return {
            course_image: '',
            course_name: '',
            course_mode: ''
        };
    }
};

// Initial state
const initialState = getInitialCourseState();

const CourseManagement = (state = initialState, action) => {
    switch (action.type) {
        case 'ADD_COURSE_DETAILS':
            const updatedState = {
                ...state,
                course_image: action.payload.image,
                course_name: action.payload.name,
                course_mode: action.payload.mode
            };
            try {
                localStorage.setItem('course_data', JSON.stringify(updatedState));
            } catch (error) {
                //console.error('Error saving course_data to localStorage:', error);
            }
            return updatedState;

        case 'RESET_COURSE_DETAILS':
            try {
                localStorage.removeItem('course_data');
            } catch (error) {
                //console.error('Error removing course_data from localStorage:', error);
            }
            return {
                course_image: '',
                course_name: '',
                course_mode: ''
            };

        default:
            return state;
    }
};

export default CourseManagement;